/** True when a fetch was cancelled via AbortController (e.g. user left the page). */
export const isAbortError = error => error?.name === 'AbortError';
